"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_CHARACTERS = exports.MOBILE_WIDTH = exports.SEIS = exports.TRES = exports.DOS = exports.EVENT_KEY = exports.EVENT_KEYDOWN = exports.EVENT_CLICK = exports.EVENT_POPSTATE = exports.HREF_ATTRIBUTE = exports.TOOLTIP_POSITION = exports.TOOLTIP_POSITION_ATTRIBUTE = exports.TOOLTIP_TEXT_ATTRIBUTE = exports.TOOLTIP_ATTRIBUTE = exports.SEPARATION_ARROW = exports.LI_TAG = exports.SPAN_TAG = exports.A_TAG = exports.TOOLTIP_CLASS = exports.ICON_CLASS = exports.ITEM_MENU_CLASS = exports.BREADCRUMB_ITEM = exports.FLOAT_MENU_OPTIONS = exports.BREADCRUMB_ITEMS = exports.BC_BREADCRUMB = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
exports.BC_BREADCRUMB = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-breadcrumb");
exports.BREADCRUMB_ITEMS = 'bc-breadcrumb-items';
exports.FLOAT_MENU_OPTIONS = 'bc-float-menu-option';
exports.BREADCRUMB_ITEM = 'item';
exports.ITEM_MENU_CLASS = 'item-menu';
exports.ICON_CLASS = 'bc-icon';
exports.TOOLTIP_CLASS = 'bc-breadcrumb-overflow';
exports.A_TAG = 'a';
exports.SPAN_TAG = 'span';
exports.LI_TAG = 'li';
exports.SEPARATION_ARROW = "<em class=\"bc-icon bc-xs\" aria-hidden=\"true\" aria-label=\"angle-right\" role=\"img\" size=\"md\" ng-reflect-size=\"md\">angle-right</em>";
exports.TOOLTIP_ATTRIBUTE = 'bc-tooltip';
exports.TOOLTIP_TEXT_ATTRIBUTE = 'bcTooltipText';
exports.TOOLTIP_POSITION_ATTRIBUTE = 'bcTooltipPosition';
exports.TOOLTIP_POSITION = 'bottom';
exports.HREF_ATTRIBUTE = 'href';
exports.EVENT_POPSTATE = 'popstate';
exports.EVENT_CLICK = 'click';
exports.EVENT_KEYDOWN = 'keydown';
exports.EVENT_KEY = 'Enter';
exports.DOS = 2;
exports.TRES = 3;
exports.SEIS = 6;
exports.MOBILE_WIDTH = 767;
exports.MAX_CHARACTERS = 30;
